import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { SignIn, Spinner } from '@phosphor-icons/react';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);
    setLoading(false);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="login-split-screen">
      <div className="flex items-center justify-center bg-white p-8">
        <div className="w-full max-w-md">
          <div className="mb-8">
            <h1 className="text-4xl font-black tracking-tight text-zinc-900 mb-2" style={{ fontFamily: 'Chivo, sans-serif' }}>
              Domain Manager
            </h1>
            <p className="text-zinc-600 font-medium">Sistema de gestión de dominios</p>
          </div>

          <div className="bg-white border border-zinc-200 rounded-lg p-8">
            <h2 className="text-2xl font-bold tracking-tight mb-6" style={{ fontFamily: 'Chivo, sans-serif' }}>
              Iniciar Sesión
            </h2>

            {error && (
              <div data-testid="login-error" className="mb-4 p-3 bg-red-50 border border-red-200 rounded text-red-700 text-sm">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="label">Email</label>
                <input
                  data-testid="login-email-input"
                  type="email"
                  className="input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="admin@domainmanager.com"
                />
              </div>

              <div className="mb-6">
                <label className="label">Contraseña</label>
                <input
                  data-testid="login-password-input"
                  type="password"
                  className="input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="••••••••"
                />
              </div>

              <button
                data-testid="login-submit-button"
                type="submit"
                disabled={loading}
                className="btn-primary w-full flex items-center justify-center gap-2"
              >
                {loading ? (
                  <Spinner className="animate-spin" size={20} />
                ) : (
                  <>
                    <SignIn size={20} />
                    <span>Ingresar</span>
                  </>
                )}
              </button>
            </form>

          </div>

        </div>
      </div>

      <div 
        className="login-image-side bg-cover bg-center relative"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1532456745301-b2c645d8b80d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMHdoaXRlJTIwYXJjaGl0ZWN0dXJhbCUyMGdyaWR8ZW58MHx8fHwxNzgyMzQ0MDk0fDA&ixlib=rb-4.1.0&q=85)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-[#002FA7]/20 to-transparent"></div>
      </div>
    </div>
  );
};

export default Login;